"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandlordWrapper = void 0;
const web3_js_1 = require("@solana/web3.js");
const plot_1 = require("./plot");
class LandlordWrapper {
    constructor(farmWrapper, landlordKey, landlordData) {
        this.farmWrapper = farmWrapper;
        this.landlordKey = landlordKey;
        this.landlordData = landlordData;
        this.saber = farmWrapper.saber;
        this.program = farmWrapper.program;
    }
    /**
     * Gets the plot associated with the given token.
     * @param token
     * @returns
     */
    getPlot(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const plotKey = yield this.getPlotKey(token);
            return yield plot_1.PlotWrapper.load({
                saber: this.saber,
                program: this.program,
                token,
                key: plotKey,
            });
        });
    }
    /**
     * Gets the public key of a plot for a token.
     * @param token
     * @returns
     */
    getPlotKey(token) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getPlotKeyForMint(token.mintAccount);
        });
    }
    /**
     * Gets the public key of a plot for a token mint.
     * @param token
     * @returns
     */
    getPlotKeyForMint(mint) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.program.account.plot.associatedAddress(this.landlordKey, mint);
        });
    }
    /**
     * Creates a new plot. Only the landlord can call this.
     * @param param0
     * @returns
     */
    createPlot({ token, rewardsShare, authority = this.program.provider.wallet.publicKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const plotKey = yield this.getPlotKey(token);
            const ix = this.program.instruction.createPlot(rewardsShare, {
                accounts: {
                    plot: plotKey,
                    auth: {
                        authority,
                        landlord: this.landlordKey,
                    },
                    tokenMint: token.mintAccount,
                    payer: this.program.provider.wallet.publicKey,
                    rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                    systemProgram: web3_js_1.SystemProgram.programId,
                },
            });
            return {
                landlord: this.landlordKey,
                plot: plotKey,
                tx: this.saber.newTx([ix]),
            };
        });
    }
    /**
     * Updates to daily rewards rate on the farm, and update rewards on plots assocated with each mint provided.
     * @param param0
     */
    setDailyRewards(newDailyRate, mints) {
        return __awaiter(this, void 0, void 0, function* () {
            const authority = this.program.provider.wallet.publicKey;
            const tx = yield this.syncPlotRewards(mints);
            tx.instructions.unshift(this.program.instruction.setDailyRewards(newDailyRate, {
                accounts: {
                    auth: {
                        landlord: this.landlordKey,
                        authority,
                    },
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                },
            }));
            return tx;
        });
    }
    /**
     * Synchronizes plot rewards.
     * @param mints
     * @returns
     */
    syncPlotRewards(mints) {
        return __awaiter(this, void 0, void 0, function* () {
            const instructions = [];
            yield Promise.all(mints.map((m) => __awaiter(this, void 0, void 0, function* () {
                const plot = yield this.getPlotKeyForMint(m);
                instructions.push(this.program.instruction.updatePlotRewards({
                    accounts: {
                        landlord: this.landlordKey,
                        plot,
                        clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                    },
                }));
            })));
            return this.saber.newTx(instructions);
        });
    }
}
exports.LandlordWrapper = LandlordWrapper;
//# sourceMappingURL=landlord.js.map